import { defaultInitialState } from '../utils';
import { CHECK_OLD_PASSWORD, CHECK_OLD_PASSWORD_DONE, CHECK_OLD_PASSWORD_ERROR, CHECK_OLD_PASSWORD_RESET } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { oldPassword: null });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_OLD_PASSWORD:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case CHECK_OLD_PASSWORD_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: true, oldPassword: action.data.password, isLoading: false, error: false, errorMessage: null });
        case CHECK_OLD_PASSWORD_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case CHECK_OLD_PASSWORD_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map